/* Progressive enhancement: all four real product previews remain available without JS. */
(() => {
  function init(root) {
    root.querySelectorAll('[data-yns-styles]').forEach((styles) => {
      if (styles.dataset.ready) return;
      const buttons = [...styles.querySelectorAll('[data-yns-style]')];
      const panels = [...styles.querySelectorAll('[data-yns-panel]')];
      if (!buttons.length || !panels.length) return;
      const select = (button) => {
        buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.ynsPanel !== button.dataset.ynsStyle; });
      };
      buttons.forEach((button) => button.addEventListener('click', () => select(button)));
      select(buttons[0]);
      styles.querySelector('.yns-styles__controls').hidden = false;
      styles.dataset.ready = 'true';
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
